import { api } from '../../../services/api';

export type ProviderAccountType = 'BANK' | 'CREDIT';

export interface ProviderAccountDTO {
  id: string;
  type: string;
  subtype: string | null;
  name: string | null;
  last4: string | null;
  companyId: string | null;
  companyName: string | null;
  linkedBankAccountId: string | null;
  linkedCardId?: string | null;
}

/** Saúde do Open Finance por conta corrente e por cartão (E7); sem texto do banco. */
export interface OpenFinanceStatusDTO {
  id: string;
  kind: 'BANK' | 'CARD';
  bankAccountId: string | null;
  cardId: string | null;
  companyId: string;
  name: string;
  lastSyncAt: string | null;
  lastError: string | null;
  errorSince: string | null;
  consentExpiresAt: string | null;
  consentEstimated: boolean;
  reportedBalance: number | null;
  balanceDivergence: number | null;
  divergence: number | null;
  divergenceSince: string | null;
}

/** Resultado da busca por conta corrente; só contagens e o código do erro. */
export interface OpenFinanceSyncResultDTO {
  bankAccountId: string;
  added: number;
  alreadySeen: number;
  skipped: number;
  sessionId: string | null;
  error: string | null;
}

/** Resultado da busca por cartão: faturas fechadas que entraram. */
export interface OpenFinanceCardSyncResultDTO {
  cardId: string;
  invoicesCreated: number;
  estimatedInvoices: number;
  itemsAdded: number;
  skippedBills: number;
  error: string | null;
}

export type OpenFinanceSyncAnyDTO = OpenFinanceSyncResultDTO | OpenFinanceCardSyncResultDTO;

export const openFinanceService = {
  accounts: (type?: ProviderAccountType) =>
    api
      .get<{ success: boolean; data: ProviderAccountDTO[] }>('/financial/open-finance/accounts', {
        params: type ? { type } : undefined,
      })
      .then((r) => r.data.data),
  status: () =>
    api
      .get<{ success: boolean; data: OpenFinanceStatusDTO[] }>('/financial/open-finance/status')
      .then((r) => r.data.data),
  sync: () =>
    api
      .post<{
        success: boolean;
        data: OpenFinanceSyncAnyDTO[];
      }>('/financial/open-finance/sync')
      .then((r) => r.data.data),
};
